/* eslint-disable indent */
import React, { useState, useRef, useLayoutEffect } from 'react'
import styled from '@emotion/styled'
import { Text } from '../styles/Components'
import { mq } from '../helpers'
import Image from 'next/image'
import ArrowUp from '../../public/images/arrow-up-red.svg'
import ArrowDown from '../../public/images/arrow-down-red.svg'
import { gsColors } from '../styles/Variables'

//Takes 3 props:
//-- List of markets
//-- "selected" market state variable
//-- function for updating selected variable

const MarketSelector = ({ markets, selected, setSelected }) => {
  const [open, setOpen] = useState(false)
  const selectRef = useRef(null)
  const listRef = useRef(null)

  useLayoutEffect(() => {
    if (selectRef.current) {
      listRef.current.style.width = `${selectRef.current.getBoundingClientRect().width}px`
    }
  }, [selected])

  const handleClick = (newMarket) => {
    setSelected(newMarket)
    setOpen(false)
  }

  return (
    <MarketSelectWrapper>
      {selected && (
        <button
          className="market-selector-container"
          onClick={() => setOpen(!open)}
          ref={selectRef}
        >
          <Text color="#000" fontSize={18}>
            {selected.name}
          </Text>
          {open ? (
            <Image src={ArrowUp} alt="" aria-hidden="true" />
          ) : (
            <Image src={ArrowDown} alt="" aria-hidden="true" />
          )}
        </button>
      )}
      <div
        className={
          open ? 'market-list-container list-open' : 'market-list-container'
        }
        ref={listRef}
      >
        {selected &&
          markets.map((m) => (
            <button
              className={`${m.id === selected.id
                ? 'market-list-item market-selected'
                : 'market-list-item'
                } ${open ? '' : 'hide'}`}
              key={m.id}
              onClick={() => handleClick(m)}
            >
              {m.name}
            </button>
          ))}
      </div>
    </MarketSelectWrapper>
  )
}

export default MarketSelector

export const MarketSelectWrapper = styled.div`
  position: relative;
  z-index: 800;

  ${mq('max', '768px')} {
    width: 100%;
  }

  .market-selector-container {
    background-color: transparent;

    border: none;
    width: max-content;
    min-width: 400px;
    padding: 12px 0;
    border-bottom: 1px solid black;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      cursor: pointer;
      color: ${gsColors.sunsetOrange};
    }

    ${mq('max', '768px')} {
      width: 100%;
      min-width: 100%;
    }

    p {
      ${mq('max', '768px')} {
        font-size: 14px !important;
      }
    }
  }

  .market-select-arrow {
    font-size: 2rem;
    margin: 0 1rem;
    transition: all 0.2s ease;
    color: ${gsColors.black};
  }

  .arrow-open {
    transform: rotate(0.5turn);
    color: ${gsColors.saltBox};
  }

  .market-list-container {
    background-color: ${gsColors.white};
    height: auto;
    max-height: 0px;
    transition: all 0.5s ease-in-out;
    position: absolute;
    overflow: hidden;
    opacity: 0;
    display: flex;
    flex-direction: column;
    z-index: 999;
    border-left: 1px solid ${gsColors.greyPoupon};
    border-right: 1px solid ${gsColors.greyPoupon};
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px 0px rgba(0, 0, 0, 0.10);

    .hide {
      display: none;
    }
  }

  .list-open {
    max-height: 1000px;
    opacity: 1;
    z-index: 999;
    transition: all 0.2s ease-in-out;
  }

  .market-list-item {
    background-color: white;
    border: none;
    border-bottom: 1px solid ${gsColors.greyPoupon};
    font-size: 18px;
    line-height: 100%;
    font-family: Euclid;
    text-align: left;
    padding: 13px 20px;
    font-weight: 400;
    color: #000;
    z-index: 9999;

    &:hover {
      cursor: pointer;
      color: ${gsColors.sunsetOrange};
    }

    ${mq('max', '768px')} {
      font-size: 14px;
    }
  }

  .market-selected {
    color: #FFF;
    background-color: ${gsColors.sunsetOrange};

    &:hover {
      cursor: pointer;
      color: ${gsColors.white};
    }
  }
`
